/**
 * Invitation names autocomplete reducer index script file
 *
 * @package    Reducers
 * @author     Roman Kritskiy <rkritskiy@mindk.com>
 * @copyright  Copyright (c) 2010-2018 MindK (http://mindk.com). All rights reserved.
 * @license    http://mindk.com
 * @link       http://mindk.com
 */
import Immutable from 'seamless-immutable';

import {
    INVITATION_NAME_AUTOCOMPLETE_REQUEST,
    INVITATION_NAME_AUTOCOMPLETE_SUCCESS,
    INVITATION_NAME_AUTOCOMPLETE_ERROR,
    INVITATION_NAME_AUTOCOMPLETE_CLEAR,
} from 'Actions/invitation';

export const INITIAL_STATE = Immutable({
    loading: false,
    success: false,
    error: false,
    filter: {
        where: {},
        limit: 10,
    },
    data: [],
    names: [],
    metadata: {},
});

export default function invitationNameAutocompleteReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case INVITATION_NAME_AUTOCOMPLETE_REQUEST:
            return state.merge({
                loading: true,
                success: false,
                error: false,
            });

        case INVITATION_NAME_AUTOCOMPLETE_SUCCESS: {
            const names = action.payload.data.map(invite => {
                return {
                    value: invite.first_name + '---' + invite.last_name,
                    label: invite.name
                };
            }).filter((object, key, array) => {
                return array
                    .map(mapObject => mapObject.value)
                    .indexOf(object.value) === key;
            });

            return state.merge({
                loading: false,
                success: true,
                error: false,
                data: action.payload.data,
                names: names
            });
        }

        case INVITATION_NAME_AUTOCOMPLETE_ERROR:
            return state.merge({
                loading: false,
                success: false,
                error: true,
            });

        case INVITATION_NAME_AUTOCOMPLETE_CLEAR:
            return INITIAL_STATE;

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/invitationNameAutocompleteReducer.js